import React from "react";
import classnames from "classnames";
import "./Checkbox.css";
import PropTypes from "prop-types";

const Checkbox = ({
  label,
  onChange,
  checked,
  className,
  disabled,
  style,
  containerClassName,
}) => (
  <div
    className={classnames(
      "col-sm-12 text-left input-label",
      containerClassName
    )}
  >
    <input
      className={classnames("check", className)}
      type="checkbox"
      checked={checked}
      onChange={e => onChange(e.target.checked)}
      disabled={disabled}
      style={style}
    />
    <label className="title" style={style}>
      {label}
    </label>
  </div>
);

Checkbox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  containerClassName: PropTypes.object,
};

Checkbox.defaultProps = {
  className: undefined,
  label: undefined,
  checked: false,
  onChange: undefined,
  containerClassName: undefined,
};
export default Checkbox;
